/* Tap Client — motor de interacciones (modo Shopify + modo preview estático) */
(function () {
  'use strict';

  var CATALOG = {
    'cartel-google': { name: 'Cartel de Google para conseguir más Calificaciones', price: 3999900, mock: 'sign-google' },
    'combo-3carteles': { name: 'Combo Cartel Instagram + Cartel Google + Cartel WhatsApp', price: 10499900, mock: 'combo-signs' },
    'combo-3stickers': { name: 'Combo calcomanía Instagram + calcomanía Google + calcomanía WhatsApp', price: 6299700, compare: 8999900, mock: 'combo-stickers', sold: true },
    'sticker-whatsapp': { name: 'Sticker de WhatsApp para vidriera', price: 2099900, compare: 2999900, mock: 'sticker-whatsapp' },
    'sticker-menu': { name: 'Sticker de Menú para vidriera', price: 2099900, compare: 2999900, mock: 'sticker-menu' },
    'sticker-google': { name: 'Sticker de Google para vidriera', price: 2099900, compare: 2999900, mock: 'sticker-google' },
    'sticker-instagram': { name: 'Sticker de Instagram para vidriera', price: 2099900, compare: 2999900, mock: 'sticker-instagram', sold: true },
    'combo-3tarjetas': { name: 'Combo 3 Tarjetas Google + 1 Cartel Google', price: 10499900, mock: 'combo-cards-sign' },
    'tarjeta-instagram': { name: 'Tarjeta de Instagram: aumentá tus seguidores', price: 2999900, mock: 'card-instagram' },
    'tarjeta-google': { name: 'Tarjeta de Google para calificaciones', price: 2999900, mock: 'card-google' },
    'tarjeta-whatsapp': { name: 'Tarjeta de WhatsApp: conectá con tus clientes', price: 2999900, mock: 'card-whatsapp' },
    'tarjeta-tiktok': { name: 'Tarjeta de TikTok: aumentá tu alcance', price: 2999900, mock: 'card-tiktok' },
    'cartel-instagram': { name: 'Cartel de Instagram: aumentá tus seguidores', price: 3999900, mock: 'sign-instagram' },
    'cartel-whatsapp': { name: 'Cartel de WhatsApp: iniciá más conversaciones', price: 3999900, mock: 'sign-whatsapp' },
    'cartel-tripadvisor': { name: 'Cartel de calificaciones para Tripadvisor', price: 3999900, mock: 'sign-tripadvisor' },
    'cartel-tiktok': { name: 'Cartel de TikTok: aumentá tus seguidores', price: 3999900, mock: 'sign-tiktok' },
    'cartel-facebook': { name: 'Cartel de Facebook: conseguí más Me Gusta', price: 3999900, mock: 'sign-facebook' },
    'combo-gw': { name: 'Combo Cartel de Google + Cartel de WhatsApp', price: 7499800, mock: 'combo-pair-gw' },
    'combo-gi': { name: 'Combo Cartel de Google + Cartel de Instagram', price: 7499800, mock: 'combo-pair-gi' },
    'combo-gt': { name: 'Combo Cartel de Google + Cartel de TripAdvisor', price: 7499800, mock: 'combo-pair-gt' },
    'combo-10ig': { name: 'Combo 10 Tarjetas de Instagram + 2 Carteles de Instagram', price: 34499900, mock: 'combo-stack-ig' },
    'combo-10g': { name: 'Combo 10 Tarjetas de Google + 2 Carteles de Google', price: 34499900, mock: 'combo-stack-google' },
    'combo-mega': { name: 'Combo 10 Tarjetas Google + 3 Tarjetas Instagram + 1 Cartel Google + 1 Cartel Instagram', price: 42999900, mock: 'combo-mega' },
    'guia': { name: 'Guía: Optimizá tu perfil de Google Mi Negocio', price: 0, mock: 'guide' }
  };
  var GIFT_THRESHOLD = 9900000;
  var isShop = !!(window.Shopify && window.Shopify.routes);

  function money(c) {
    var fmt = (window.themeMoneyFormat || '${{amount_with_comma_separator}}').toString();
    var neg = c < 0; c = Math.abs(c);
    var int = Math.floor(c / 100), dec = c % 100;
    var dec2 = String(dec).padStart(2, '0');
    var dotted = String(int).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var plain = int + '.' + dec2;
    var amount = fmt.indexOf('amount_with_comma_separator') > -1 ? dotted + ',' + dec2
      : fmt.indexOf('amount_no_decimals') > -1 ? dotted
      : plain;
    return (neg ? '-' : '') + fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- header ---------- */
  /* Menú primario en el flujo normal (anclado arriba, se desplaza con la página).
     Segundo estilo (barra sólida fija): aparece solo al subir desde abajo
     (a partir de "Los más elegidos") y se oculta al bajar. */
  var wrap = $('[data-header]');
  var stickyStart = $('[data-sticky-header-start]');
  var lastY = window.scrollY;
  if (!$('.hero')) wrap.classList.add('is-solid');
  function onScroll() {
    var y = window.scrollY;
    var pastStart = stickyStart
      ? stickyStart.getBoundingClientRect().top <= 100
      : y > 320;
    var goingUp = y < lastY - 4;
    var goingDown = y > lastY + 4;
    if (pastStart && goingUp) {
      if (!wrap.classList.contains('is-fixed')) {
        wrap.classList.add('is-fixed');
        requestAnimationFrame(function () { wrap.classList.add('is-shown'); });
      }
    } else if (goingDown || !pastStart) {
      if (goingDown && wrap.classList.contains('is-shown')) {
        wrap.classList.remove('is-shown');
      } else if (!pastStart && wrap.classList.contains('is-fixed')) {
        wrap.classList.remove('is-fixed', 'is-shown');
      }
    }
    lastY = y;
    var top = $('[data-to-top]');
    if (top) top.classList.toggle('is-on', y > 800);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  var toTop = $('[data-to-top]');
  if (toTop) toTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' }); });

  /* ---------- paneles ---------- */
  var scrim = $('[data-scrim]');
  function openPanel(el) { el.classList.add('is-open'); if (scrim) scrim.classList.add('is-on'); }
  function closePanels() {
    $$('[data-menu-drawer],[data-cart-drawer]').forEach(function (p) { p.classList.remove('is-open'); });
    var sm = $('[data-search-modal]'); if (sm) sm.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-on');
  }
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { openPanel($('[data-menu-drawer]')); }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', closePanels); });
  if (scrim) scrim.addEventListener('click', closePanels);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(); });

  /* ---------- hero ---------- */
  var slides = $$('.hero__slide'), dotsBox = $('[data-hero-dots]'), hi = 0;
  if (slides.length && dotsBox) {
    slides.forEach(function (_, i) {
      var d = document.createElement('button');
      d.setAttribute('role', 'tab');
      d.setAttribute('aria-label', 'Diapositiva ' + (i + 1));
      d.addEventListener('click', function () { go(i); });
      dotsBox.appendChild(d);
    });
    var stage = $('[data-hero]'), tx = null;
    function go(i) {
      hi = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === hi); });
      $$('button', dotsBox).forEach(function (d, k) { d.classList.toggle('is-on', k === hi); });
    }
    /* autoplay cada 5 segundos */
    if (!reduced) {
      setInterval(function () { go(hi + 1); }, 5000);
    }
    if (stage) {
      stage.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (tx === null) return;
        var dx = e.changedTouches[0].clientX - tx;
        if (Math.abs(dx) > 50) go(hi + (dx < 0 ? 1 : -1));
        tx = null;
      }, { passive: true });
    }
    go(0);
  }

  /* ---------- hero: el subtítulo hereda el ancho de la línea del eyebrow ---------- */
  function syncHeroMeasure() {
    var st = $('[data-hero]');
    if (!st) return;
    var eb = $('.hero__eyebrow', $('.hero__slide', st) || st);
    if (!eb) return;
    var probe = eb.cloneNode(true);
    probe.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;width:auto;max-width:none;';
    eb.parentNode.appendChild(probe);
    var full = probe.offsetWidth;
    probe.parentNode.removeChild(probe);
    var avail = eb.parentElement.clientWidth || st.clientWidth;
    st.style.setProperty('--hero-measure', Math.min(full, avail) + 'px');
  }
  syncHeroMeasure();
  window.addEventListener('resize', syncHeroMeasure);
  window.addEventListener('load', syncHeroMeasure);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncHeroMeasure);

  /* ---------- reveals / stats ---------- */
  function runCount(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    var pre = el.getAttribute('data-prefix') || '', suf = el.getAttribute('data-suffix') || '';
    if (isNaN(target)) { el.textContent = pre + (el.getAttribute('data-count') || '0') + suf; return; }
    if (reduced) { el.textContent = pre + target + suf; return; }
    var t0 = performance.now();
    (function tick(t) {
      var k = Math.min(1, (t - t0) / 1200);
      el.textContent = pre + Math.round(target * (1 - Math.pow(1 - k, 3))) + suf;
      if (k < 1) requestAnimationFrame(tick);
    })(t0);
  }
  if ('IntersectionObserver' in window && !reduced) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
    var ioStats = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        ioStats.unobserve(e.target);
        $$('[data-donut]', e.target).forEach(function (c) {
          c.style.strokeDashoffset = (226.2 * (1 - +c.getAttribute('data-donut') / 100)).toFixed(1);
        });
        $$('[data-count]', e.target).forEach(runCount);
      });
    }, { threshold: 0.4 });
    $$('[data-stats],.trustband').forEach(function (el) { ioStats.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
    $$('[data-donut]').forEach(function (c) { c.style.strokeDashoffset = (226.2 * (1 - +c.getAttribute('data-donut') / 100)).toFixed(1); });
    $$('[data-count]').forEach(runCount);
  }

  /* ---------- galería + lightbox ---------- */
  var gal = $('[data-gallery]');
  if (gal) {
    var views = $$('[data-view]', gal), thumbs = $$('[data-thumb]', gal), cur = 0;
    function setView(i) {
      cur = i;
      views.forEach(function (v, k) {
        v.classList.toggle('is-on', k === i);
        if (v.tagName === 'IMG') v.style.opacity = k === i ? '1' : '0';
      });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { setView(+t.getAttribute('data-thumb')); }); });
    var lb = $('[data-lightbox]');
    var openLb = $('[data-lightbox-open]');
    if (openLb && lb) openLb.addEventListener('click', function () {
      var v = views[cur];
      var img = $('[data-lightbox-img-src]', lb), svgUse = $('[data-lightbox-img] use', lb);
      if (v && v.tagName === 'IMG') { img.src = v.src; img.hidden = false; if (svgUse) svgUse.closest('svg').style.display = 'none'; }
      else if (svgUse) { svgUse.setAttribute('href', $('use', v).getAttribute('href')); img.hidden = true; svgUse.closest('svg').style.display = ''; }
      lb.classList.add('is-open');
    });
    $$('[data-lightbox-close]').forEach(function (b) { b.addEventListener('click', function () { lb.classList.remove('is-open'); }); });
    if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) lb.classList.remove('is-open'); });
  }

  /* ---------- promos ---------- */
  var promo = $('[data-promo]');
  if (promo) {
    promo.addEventListener('change', function (e) {
      var input = e.target;
      if (input.tagName !== 'INPUT') return;
      var out = $('[data-price]');
      if (out && !isShop) out.textContent = money(+input.getAttribute('data-price'));
      $$('[data-promo-qty]').forEach(function (q) { q.value = input.value; });
    });
  }

  /* ---------- hotspots ---------- */
  $$('[data-hotspot]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var h = btn.closest('.hotspot-wrap') || btn.parentNode;
      var was = h.classList.contains('is-open');
      $$('.hotspot-wrap').forEach(function (o) {
        o.classList.remove('is-open');
        var b = $('[data-hotspot]', o); if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!was) { h.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    });
  });
  document.addEventListener('click', function () {
    $$('.hotspot-wrap').forEach(function (o) {
      o.classList.remove('is-open');
      var b = $('[data-hotspot]', o); if (b) b.setAttribute('aria-expanded', 'false');
    });
  });

  /* ---------- toast ---------- */
  var toastEl = $('[data-toast]'), toastT = null;
  function toast(msg) {
    if (!toastEl) return;
    $('[data-toast-msg]', toastEl).textContent = msg;
    toastEl.classList.add('is-on');
    if (toastT) clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2800);
  }

  /* ---------- carrito: modo preview ---------- */
  var local = {
    items: [],
    load: function () { try { this.items = JSON.parse(localStorage.getItem('tapclient_cart') || '[]'); } catch (e) { this.items = []; } },
    save: function () { localStorage.setItem('tapclient_cart', JSON.stringify(this.items)); },
    add: function (id, qty, unit) {
      var f = this.items.filter(function (i) { return i.id === id && i.unit === unit; })[0];
      if (f) f.qty += qty; else this.items.push({ id: id, qty: qty, unit: unit });
      this.save(); renderLocal();
    },
    setQty: function (id, unit, qty) {
      this.items = this.items.filter(function (i) { return !(i.id === id && i.unit === unit) || qty > 0; });
      var f = this.items.filter(function (i) { return i.id === id && i.unit === unit; })[0];
      if (f) f.qty = qty;
      this.save(); renderLocal();
    },
    subtotal: function () { return this.items.reduce(function (a, i) { return a + i.unit * i.qty; }, 0); }
  };

  function giftUI(sub) {
    var giftBox = $('[data-gift]');
    if (!giftBox) return false;
    var bar = $('[data-gift-bar]', giftBox), msg = $('[data-gift-msg]', giftBox);
    var p = Math.min(1, sub / GIFT_THRESHOLD);
    if (bar) bar.style.width = (p * 100) + '%';
    var unlocked = sub >= GIFT_THRESHOLD;
    giftBox.classList.toggle('is-unlocked', unlocked);
    if (msg) msg.innerHTML = unlocked
      ? '¡Desbloqueaste tu <em>regalo</em>! 🎁'
      : 'Te faltan <em>' + money(GIFT_THRESHOLD - sub) + '</em> para desbloquear tu <em>regalo</em>';
    return unlocked;
  }

  function renderLocal() {
    var box = $('[data-cart-items]'); if (!box) return;
    var count = local.items.reduce(function (a, i) { return a + i.qty; }, 0);
    var bubble = $('[data-cart-count]');
    if (bubble) { bubble.textContent = count; bubble.hidden = count === 0; bubble.classList.remove('bump'); void bubble.offsetWidth; bubble.classList.add('bump'); }
    var sub = local.subtotal();
    var subEl = $('[data-cart-subtotal]'); if (subEl) subEl.textContent = money(sub);
    var co = $('[data-checkout]'); if (co) co.disabled = local.items.length === 0;
    var unlocked = giftUI(sub);
    if (unlocked && !local.items.some(function (i) { return i.id === 'guia'; })) {
      local.items.push({ id: 'guia', qty: 1, unit: 0 });
      local.save();
      toast('¡Desbloqueaste la guía de regalo!');
    }
    if (local.items.length === 0) {
      box.innerHTML = '<div class="drawer__empty"><h3>Tu carrito está vacío</h3><p>Sumá tu primer cartel y empezá a recibir calificaciones.</p><button class="button button--deep button--upper" data-cart-close>Seguir comprando</button></div>';
    } else {
      box.innerHTML = local.items.map(function (i) {
        var p = CATALOG[i.id] || { name: i.id, mock: 'sign-google' };
        return '<div class="citem">' +
          '<span class="citem__img"><svg viewBox="0 0 400 400"><use href="#' + p.mock + '"/></svg></span>' +
          '<span><b>' + p.name + '</b><span class="citem__meta">' + money(i.unit) + ' c/u</span>' +
          '<span class="qty"><button data-q="-1" data-id="' + i.id + '" data-unit="' + i.unit + '" aria-label="Menos"><svg viewBox="0 0 24 24"><path d="M5 12h14"/></svg></button><span>' + i.qty + '</span><button data-q="1" data-id="' + i.id + '" data-unit="' + i.unit + '" aria-label="Más"><svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg></button></span></span>' +
          '<span class="citem__right"><span class="citem__price">' + money(i.unit * i.qty) + '</span><button class="citem__remove" data-rm="' + i.id + '" data-unit="' + i.unit + '">Quitar</button></span></div>';
      }).join('');
    }
    bindLocalItems(box);
  }
  function bindLocalItems(box) {
    $$('[data-cart-close]', box).forEach(function (b) { b.addEventListener('click', closePanels); });
  }

  /* Cambios de cantidad / eliminar: delegados (funciona con ítems renderizados
     por Liquid en el drawer y la página de carrito, y con los re-render por JS) */
  function cartChangeShop(key, qty) {
    post(window.Shopify.routes.cart_change_url + '.js', { id: key, quantity: qty }).then(fetchCart).then(renderShop).catch(function () { toast('No pudimos actualizar el carrito. Intentá de nuevo.'); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-q], [data-rm-key], [data-rm]');
    if (!btn) return;
    var box = btn.closest('[data-cart-items]');
    if (!box) return;
    if (btn.hasAttribute('data-rm-key') || btn.hasAttribute('data-q')) {
      var qty = btn.hasAttribute('data-rm-key') ? 0 : +btn.getAttribute('data-qty') + +btn.getAttribute('data-q');
      if (isShop) {
        var key = btn.getAttribute('data-key') || btn.getAttribute('data-rm-key');
        if (key) cartChangeShop(key, qty);
      } else {
        var id = btn.getAttribute('data-id') || btn.getAttribute('data-rm');
        var unit = +btn.getAttribute('data-unit');
        if (id) {
          var it = local.items.filter(function (i) { return i.id === id && i.unit === unit; })[0];
          if (it) local.setQty(id, unit, qty);
        }
      }
    }
  });

  /* ---------- carrito: modo Shopify ---------- */
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }
  function fetchCart() { return fetch(window.Shopify.routes.cart_url + '.js').then(function (r) { return r.json(); }); }
  function renderShop(state) {
    var box = $('[data-cart-items]'); if (!box) return;
    var bubble = $('[data-cart-count]');
    if (bubble) { bubble.textContent = state.item_count; bubble.hidden = state.item_count === 0; bubble.classList.remove('bump'); void bubble.offsetWidth; bubble.classList.add('bump'); }
    var subEl = $('[data-cart-subtotal]'); if (subEl) subEl.textContent = money(state.total_price);
    var co = $('[data-checkout]'); if (co) co.disabled = state.item_count === 0;
    var unlocked = giftUI(state.total_price);
    if (unlocked && !sessionStorage.getItem('tapclient_gift_toast')) {
      sessionStorage.setItem('tapclient_gift_toast', '1');
      toast('¡Desbloqueaste la guía de regalo! Se agrega al pagar.');
    }
    if (state.item_count === 0) {
      box.innerHTML = '<div class="drawer__empty"><h3>Tu carrito está vacío</h3><p>Sumá tu primer cartel y empezá a recibir calificaciones.</p><button class="button button--deep button--upper" data-cart-close>Seguir comprando</button></div>';
      $$('[data-cart-close]', box).forEach(function (b) { b.addEventListener('click', closePanels); });
    } else {
      box.innerHTML = state.items.map(function (i) {
        return '<div class="citem">' +
          '<span class="citem__img">' + (i.image ? '<img src="' + i.image + '" alt="" style="width:100%;height:100%;object-fit:contain">' : '<svg viewBox="0 0 400 400"><use href="#sign-google"/></svg>') + '</span>' +
          '<span><b>' + i.title + '</b><span class="citem__meta">' + money(i.final_price) + ' c/u</span>' +
          '<span class="qty"><button type="button" data-q="-1" data-key="' + i.key + '" data-qty="' + i.quantity + '" aria-label="Menos"><svg viewBox="0 0 24 24"><path d="M5 12h14"/></svg></button><span>' + i.quantity + '</span><button type="button" data-q="1" data-key="' + i.key + '" data-qty="' + i.quantity + '" aria-label="Más"><svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg></button></span></span>' +
          '<span class="citem__right"><span class="citem__price">' + money(i.final_line_price) + '</span><button type="button" class="citem__remove" data-rm-key="' + i.key + '">Quitar</button></span></div>';
      }).join('');
    }
  }

  /* ---------- hold timer ---------- */
  var holdSecs = 300, holdInt = null;
  function startHold() {
    holdSecs = 300;
    if (holdInt) clearInterval(holdInt);
    holdInt = setInterval(function () {
      holdSecs--;
      var el = $('[data-hold-timer]');
      if (el) el.textContent = String(Math.floor(holdSecs / 60)).padStart(2, '0') + ':' + String(holdSecs % 60).padStart(2, '0');
      if (holdSecs <= 0) clearInterval(holdInt);
    }, 1000);
  }

  /* ---------- agregar al carrito ---------- */
  $$('[data-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var handle = btn.getAttribute('data-add');
      var p = CATALOG[handle];
      if (!isShop && (!p || p.sold)) return;
      var qty = 1;
      if (btn.hasAttribute('data-qty-from-promo') && promo) {
        var sel = $('input:checked', promo);
        if (sel) qty = +sel.value;
      }
      var old = btn.innerHTML;
      btn.innerHTML = '<span class="spin"></span> Agregando…';
      btn.disabled = true;
      var done = function () {
        btn.innerHTML = old; btn.disabled = false;
        startHold();
        toast('Producto agregado al carrito');
        openPanel($('[data-cart-drawer]'));
      };
      if (isShop) {
        var variant = btn.getAttribute('data-variant');
        if (!variant) return;
        post(window.Shopify.routes.cart_add_url + '.js', { id: variant, quantity: qty }).then(fetchCart).then(function (st) { renderShop(st); done(); }).catch(function () { btn.innerHTML = old; btn.disabled = false; toast('No pudimos agregar el producto. Intentá de nuevo.'); });
      } else {
        setTimeout(function () {
          local.add(handle, qty, p.price);
          done();
        }, 450);
      }
    });
  });

  /* formularios de producto (Shopify): alta por AJAX para evitar el redirect 302 */
  $$('form[action*="/cart/add"]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = f.querySelector('[type=submit]');
      var old = btn ? btn.innerHTML : '';
      if (btn) { btn.innerHTML = '<span class="spin"></span> Agregando…'; btn.disabled = true; }
      var qtyInput = f.querySelector('input[name="quantity"]');
      var qty = qtyInput ? +qtyInput.value || 1 : 1;
      var idInput = f.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) { if (btn) { btn.innerHTML = old; btn.disabled = false; } return; }
      post(window.Shopify.routes.cart_add_url + '.js', { id: idInput.value, quantity: qty })
        .then(fetchCart)
        .then(function (st) {
          renderShop(st);
          if (btn) { btn.innerHTML = old; btn.disabled = false; }
          startHold();
          toast('Producto agregado al carrito');
          openPanel($('[data-cart-drawer]'));
        })
        .catch(function () {
          if (btn) { btn.innerHTML = old; btn.disabled = false; }
          toast('No pudimos agregar el producto. Intentá de nuevo.');
        });
    });
  });

  $$('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      openPanel($('[data-cart-drawer]'));
      startHold();
      if (isShop) fetchCart().then(renderShop);
    });
  });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closePanels); });
  if (!isShop) {
    var co = $('[data-checkout]');
    if (co) co.addEventListener('click', function () { toast('Redirigiendo al pago seguro…'); });
  }

  /* ---------- búsqueda ---------- */
  var sm = $('[data-search-modal]'), si = $('[data-search-input]'), sr = $('[data-search-results]');
  $$('[data-search-open]').forEach(function (b) {
    b.addEventListener('click', function () { sm.classList.add('is-open'); if (scrim) scrim.classList.add('is-on'); setTimeout(function () { si.focus(); }, 60); });
  });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', closePanels); });
  if (sm) sm.addEventListener('click', function (e) { if (e.target === sm) closePanels(); });
  function hitRow(id, name, price, mock, variant) {
    return '<button class="search-hit" data-search-add="' + id + '" data-variant="' + (variant || '') + '">' +
      (mock.indexOf('http') === 0 ? '<img src="' + mock + '" alt="" style="width:54px;height:54px;object-fit:contain">' : '<svg viewBox="0 0 400 400"><use href="#' + mock + '"/></svg>') +
      '<span><b>' + name + '</b><span>' + money(price) + '</span></span></button>';
  }
  function bindHits() {
    $$('[data-search-add]', sr).forEach(function (b) {
      b.addEventListener('click', function () {
        closePanels();
        if (isShop) {
          var v = b.getAttribute('data-variant');
          if (v) post(window.Shopify.routes.cart_add_url + '.js', { id: v, quantity: 1 }).then(fetchCart).then(function (st) { renderShop(st); toast('Agregado al carrito'); openPanel($('[data-cart-drawer]')); });
        } else {
          var id = b.getAttribute('data-search-add');
          local.add(id, 1, CATALOG[id].price);
          toast('Agregado al carrito');
          openPanel($('[data-cart-drawer]'));
        }
      });
    });
  }
  if (si) si.addEventListener('input', function () {
    var q = si.value.trim().toLowerCase();
    if (!q) { sr.innerHTML = '<p class="search-modal__empty">Escribí para buscar carteles, calcomanías, tarjetas o combos.</p>'; return; }
    if (isShop) {
      fetch(window.Shopify.routes.predictive_search_url + '.js?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var ps = (j.resources && j.resources.results) || [];
          sr.innerHTML = ps.length ? ps.map(function (p) { return hitRow(p.id, p.title, p.price || p.variants[0].price, p.featured_image ? p.featured_image.url : 'sign-google', p.variants[0].id); }).join('') : '<p class="search-modal__empty">Sin resultados para “' + si.value + '”.</p>';
          bindHits();
        });
    } else {
      var hits = Object.keys(CATALOG).filter(function (k) { return CATALOG[k].name.toLowerCase().indexOf(q) > -1; }).slice(0, 6);
      sr.innerHTML = hits.length ? hits.map(function (k) { return hitRow(k, CATALOG[k].name, CATALOG[k].price, CATALOG[k].mock, ''); }).join('') : '<p class="search-modal__empty">Sin resultados para “' + si.value + '”. Probá con “cartel”, “calcomanía” o “combo”.</p>';
      bindHits();
    }
  });

  /* ---------- orden de colección (Shopify) ---------- */
  var sortUrl = $('[data-sort-url]');
  if (sortUrl) {
    sortUrl.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sortUrl.value);
      window.location = u.toString();
    });
  }
  var sortSel = $('[data-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var grid = $('[data-pgrid]');
      var cards = $$('.pcard', grid);
      var v = sortSel.value;
      cards.sort(function (a, b) {
        if (v === 'price-asc') return (+a.getAttribute('data-price')) - (+b.getAttribute('data-price'));
        if (v === 'price-desc') return (+b.getAttribute('data-price')) - (+a.getAttribute('data-price'));
        if (v === 'az') return a.getAttribute('data-name').localeCompare(b.getAttribute('data-name'), 'es');
        if (v === 'za') return b.getAttribute('data-name').localeCompare(a.getAttribute('data-name'), 'es');
        return 0;
      });
      cards.forEach(function (c) { grid.appendChild(c); });
    });
  }

  /* ---------- sticky ATC ---------- */
  var mainAtc = $('#MainAtc'), stickyAtc = $('.sticky-atc');
  if (mainAtc && stickyAtc && 'IntersectionObserver' in window) {
    var atcObs = new IntersectionObserver(function (es) {
      stickyAtc.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    atcObs.observe(mainAtc);
    $$('[data-sticky-add]', stickyAtc).forEach(function (b) {
      b.addEventListener('click', function () { mainAtc.click(); });
    });
  }

  /* ---------- newsletter ---------- */
  $$('[data-newsletter]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      if (!isShop) e.preventDefault();
      f.classList.add('is-ok');
      var i = $('input[type="email"]', f); if (i) i.value = '';
    });
  });

  if (isShop) fetchCart().then(renderShop); else { local.load(); renderLocal(); }
})();

/* ---------- lightbox: zoom de capturas del panel (qrstats) ---------- */
(function () {
  var shots = document.querySelectorAll('.qrstats__shot img');
  if (!shots.length) return;
  var lb = document.createElement('div');
  lb.className = 'qrstats-lightbox';
  lb.setAttribute('role', 'dialog');
  lb.setAttribute('aria-modal', 'true');
  lb.setAttribute('aria-label', 'Captura ampliada del panel');
  lb.innerHTML = '<button class="qrstats-lightbox__close" type="button" aria-label="Cerrar (Esc)">✕</button><img alt="">';
  document.body.appendChild(lb);
  var img = lb.querySelector('img');
  var closeBtn = lb.querySelector('.qrstats-lightbox__close');
  function openLb(src, alt) {
    img.src = src; img.alt = alt || '';
    lb.classList.add('is-on');
    document.documentElement.style.overflow = 'hidden';
    closeBtn.focus();
  }
  function closeLb() {
    if (!lb.classList.contains('is-on')) return;
    lb.classList.remove('is-on');
    document.documentElement.style.overflow = '';
    img.src = '';
  }
  Array.prototype.forEach.call(shots, function (s) {
    s.setAttribute('tabindex', '0');
    s.setAttribute('role', 'button');
    s.setAttribute('aria-label', 'Ampliar captura');
    s.addEventListener('click', function () { openLb(s.currentSrc || s.src, s.alt); });
    s.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLb(s.currentSrc || s.src, s.alt); }
    });
  });
  closeBtn.addEventListener('click', closeLb);
  lb.addEventListener('click', function (e) { if (e.target !== img) closeLb(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
})();
